import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    "data-testid": "global-search-loading"
};
const _hoisted_2 = {
    key: 1,
    "data-testid": "global-search-empty"
};
const _hoisted_3 = {
    key: 0,
    "data-testid": "global-search-error"
};
const _hoisted_4 = ["id", "aria-label"];
const _hoisted_5 = ["aria-labelledby"];
const _hoisted_6 = ["id"];
const _hoisted_7 = ["id", "aria-selected", "onClick"];
const _hoisted_8 = { class: "flex min-w-0 flex-col" };
const _hoisted_9 = { class: "truncate text-(length:--size-m) font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)" };
const _hoisted_10 = {
    key: 0,
    class: "truncate text-(length:--size-sm) text-(--colors-text-body-subtle)"
};
const _hoisted_11 = ["id", "aria-selected"];
const _hoisted_12 = ["aria-labelledby"];
const _hoisted_13 = ["id"];
const _hoisted_14 = ["id", "aria-selected", "onClick"];
const _hoisted_15 = { class: "flex min-w-0 flex-col" };
const _hoisted_16 = { class: "truncate text-(length:--size-m) font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)" };
const _hoisted_17 = {
    key: 0,
    class: "truncate text-(length:--size-sm) text-(--colors-text-body-subtle)"
};
const _hoisted_18 = ["id", "aria-selected"];
import { computed } from "vue";
import { Avatar } from "@eudonet/opal";
import { GLOBAL_SEARCH_CONTACTS_HEADING_ID, GLOBAL_SEARCH_LISTBOX_ID, GLOBAL_SEARCH_ORGANISATIONS_HEADING_ID, GLOBAL_SEARCH_MAX_PER_GROUP, globalSearchOptionId, globalSearchSeeAllOptionId, } from "./globalSearchOptions";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GlobalSearchResults',
    props: {
        results: {},
        isLoading: { type: Boolean },
        error: { type: Boolean },
        query: {},
        activeOptionId: {}
    },
    emits: ["select", "seeAll"],
    setup(__props) {
        const props = __props;
        const isEmpty = computed(() => props.results.contacts.length === 0 && props.results.organisations.length === 0);
        const showError = computed(() => props.error && !props.isLoading);
        const hasStatus = computed(() => props.isLoading || props.error || isEmpty.value);
        const visibleContacts = computed(() => props.results.contacts.slice(0, GLOBAL_SEARCH_MAX_PER_GROUP));
        const visibleOrganisations = computed(() => props.results.organisations.slice(0, GLOBAL_SEARCH_MAX_PER_GROUP));
        // CONSTRAINT: must match globalSearchOptions(), which the parent's keyboard navigation walks.
        const hasMoreContacts = computed(() => props.results.contacts.length > visibleContacts.value.length);
        const hasMoreOrganisations = computed(() => props.results.organisations.length > visibleOrganisations.value.length);
        function ariaSelected(id) {
            return id === props.activeOptionId ? "true" : "false";
        }
        function activeClass(id) {
            return id === props.activeOptionId ? "bg-background-hover dark:bg-white/8" : "";
        }
        function contactName(contact) {
            return `${contact.firstName} ${contact.lastName}`.trim() || contact.id;
        }
        function contactSubtitle(contact) {
            return contact.organisationName ?? contact.primaryEmail ?? null;
        }
        function organisationSubtitle(organisation) {
            return organisation.tradeName ?? organisation.acronym ?? null;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "data-testid": "global-search-results",
                class: "bg-white-50-opacity-bold border-border-base-soft box-border flex max-h-[min(420px,calc(100vh-96px))] w-full flex-col items-stretch gap-1.5 overflow-y-auto rounded-(--border-border-radius-rounded-l) border border-solid p-2 shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
                onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"]))
            }, [
                _createElementVNode("div", {
                    role: "status",
                    "data-testid": "global-search-status",
                    class: _normalizeClass(__props.isLoading || (isEmpty.value && !__props.error) ? 'px-2 py-3 text-(length:--size-m) text-(--colors-text-body-subtle)' : 'sr-only')
                }, [
                    (__props.isLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("navbar.search.loading")), 1 /* TEXT */))
                        : (isEmpty.value && !__props.error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("navbar.search.noResults")), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */),
                _createElementVNode("div", {
                    role: "alert",
                    "data-testid": "global-search-alert",
                    class: _normalizeClass(showError.value ? 'px-2 py-3 text-(length:--size-m) text-(--colors-text-body-subtle)' : 'sr-only')
                }, [
                    (showError.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("navbar.search.error")), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */),
                (!hasStatus.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: _unref(GLOBAL_SEARCH_LISTBOX_ID),
                        role: "listbox",
                        "aria-label": _ctx.$t('navbar.searchPlaceholder'),
                        "data-testid": "global-search-listbox",
                        class: "flex flex-col items-stretch gap-1.5"
                    }, [
                        (__props.results.contacts.length > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                role: "group",
                                "aria-labelledby": _unref(GLOBAL_SEARCH_CONTACTS_HEADING_ID),
                                class: "flex flex-col items-stretch"
                            }, [
                                _createElementVNode("div", {
                                    id: _unref(GLOBAL_SEARCH_CONTACTS_HEADING_ID),
                                    class: "w-full px-2 pt-0.5 pb-1 leading-5 font-medium text-(length:--size-sm) text-(--colors-text-body-subtle)"
                                }, _toDisplayString(_ctx.$t("navbar.search.contacts")), 9 /* TEXT, PROPS */, _hoisted_6),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleContacts.value, (contact) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        id: _unref(globalSearchOptionId)('contact', contact.id),
                                        key: `contact-${contact.id}`,
                                        role: "option",
                                        "aria-selected": ariaSelected(_unref(globalSearchOptionId)('contact', contact.id)),
                                        "data-testid": "global-search-contact",
                                        class: _normalizeClass([
                                            'hover:bg-background-hover inline-flex w-full cursor-pointer items-center gap-2 rounded-(--border-border-radius-rounded-sm) p-2 text-left transition-colors dark:hover:bg-white/8',
                                            activeClass(_unref(globalSearchOptionId)('contact', contact.id)),
                                        ]),
                                        onClick: ($event) => (_ctx.$emit('select', { kind: 'contact', id: contact.id }))
                                    }, [
                                        _createVNode(_unref(Avatar), {
                                            presentational: "",
                                            as: "span",
                                            name: contactName(contact),
                                            img: contact.avatarUrl ?? undefined
                                        }, null, 8 /* PROPS */, ["name", "img"]),
                                        _createElementVNode("span", _hoisted_8, [
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(contactName(contact)), 1 /* TEXT */),
                                            (contactSubtitle(contact))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(contactSubtitle(contact)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ], 10 /* CLASS, PROPS */, _hoisted_7));
                                }), 128 /* KEYED_FRAGMENT */)),
                                (hasMoreContacts.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        id: _unref(globalSearchSeeAllOptionId)('contact'),
                                        role: "option",
                                        "aria-selected": ariaSelected(_unref(globalSearchSeeAllOptionId)('contact')),
                                        "data-testid": "global-search-more-contacts",
                                        class: _normalizeClass([
                                            'hover:bg-background-hover w-full cursor-pointer rounded-(--border-border-radius-rounded-sm) px-2 py-1 text-left font-medium text-(length:--size-sm) text-(--colors-text-link) transition-colors dark:hover:bg-white/8',
                                            activeClass(_unref(globalSearchSeeAllOptionId)('contact')),
                                        ]),
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('seeAll', 'contact')))
                                    }, _toDisplayString(_ctx.$t("navbar.search.seeAllContacts", { count: __props.results.totalContacts })), 11 /* TEXT, CLASS, PROPS */, _hoisted_11))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_5))
                            : _createCommentVNode("v-if", true),
                        (__props.results.organisations.length > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                role: "group",
                                "aria-labelledby": _unref(GLOBAL_SEARCH_ORGANISATIONS_HEADING_ID),
                                class: "flex flex-col items-stretch"
                            }, [
                                _createElementVNode("div", {
                                    id: _unref(GLOBAL_SEARCH_ORGANISATIONS_HEADING_ID),
                                    class: "w-full px-2 pt-0.5 pb-1 leading-5 font-medium text-(length:--size-sm) text-(--colors-text-body-subtle)"
                                }, _toDisplayString(_ctx.$t("navbar.search.organisations")), 9 /* TEXT, PROPS */, _hoisted_13),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleOrganisations.value, (organisation) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        id: _unref(globalSearchOptionId)('organisation', organisation.id),
                                        key: `organisation-${organisation.id}`,
                                        role: "option",
                                        "aria-selected": ariaSelected(_unref(globalSearchOptionId)('organisation', organisation.id)),
                                        "data-testid": "global-search-organisation",
                                        class: _normalizeClass([
                                            'hover:bg-background-hover inline-flex w-full cursor-pointer items-center gap-2 rounded-(--border-border-radius-rounded-sm) p-2 text-left transition-colors dark:hover:bg-white/8',
                                            activeClass(_unref(globalSearchOptionId)('organisation', organisation.id)),
                                        ]),
                                        onClick: ($event) => (_ctx.$emit('select', { kind: 'organisation', id: organisation.id }))
                                    }, [
                                        _createVNode(_unref(Avatar), {
                                            presentational: "",
                                            as: "span",
                                            entity: "organisation",
                                            name: organisation.legalName,
                                            img: organisation.logoUrl ?? undefined
                                        }, null, 8 /* PROPS */, ["name", "img"]),
                                        _createElementVNode("span", _hoisted_15, [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(organisation.legalName), 1 /* TEXT */),
                                            (organisationSubtitle(organisation))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(organisationSubtitle(organisation)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ], 10 /* CLASS, PROPS */, _hoisted_14));
                                }), 128 /* KEYED_FRAGMENT */)),
                                (hasMoreOrganisations.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        id: _unref(globalSearchSeeAllOptionId)('organisation'),
                                        role: "option",
                                        "aria-selected": ariaSelected(_unref(globalSearchSeeAllOptionId)('organisation')),
                                        "data-testid": "global-search-more-organisations",
                                        class: _normalizeClass([
                                            'hover:bg-background-hover w-full cursor-pointer rounded-(--border-border-radius-rounded-sm) px-2 py-1 text-left font-medium text-(length:--size-sm) text-(--colors-text-link) transition-colors dark:hover:bg-white/8',
                                            activeClass(_unref(globalSearchSeeAllOptionId)('organisation')),
                                        ]),
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('seeAll', 'organisation')))
                                    }, _toDisplayString(_ctx.$t("navbar.search.seeAllOrganisations", { count: __props.results.totalOrganisations })), 11 /* TEXT, CLASS, PROPS */, _hoisted_18))
                                    : _createCommentVNode("v-if", true)
                            ], 8 /* PROPS */, _hoisted_12))
                            : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_4))
                    : _createCommentVNode("v-if", true)
            ], 32 /* NEED_HYDRATION */));
        };
    }
});
